import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "2",
  viewBox: "0 0 16 2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      id: "minus",
      d: "M1180,99h-14a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1h14a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1Z",
      transform: "translate(-1165 -99)",
      class: _normalizeClass('fill-' + _ctx.color)
    }, null, 2)
  ]))
}